import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const options = {
  responsive: true,
  spanGaps: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
    tooltip: {
      enabled: false,
    },
  },
  scales: {
    xAxis: {
      grid: {
        display: false,
      },
      ticks: {
        font: {
          family: 'IRANYekanX',
        },
      },
    },
    yAxis: {
      ticks: {
        font: {
          family: 'IRANYekanX',
        },
      },
    },
  },

  elements: {
    line: {
      fill: false,
      borderWidth: 0,
    },
    point: {
      radius: 6,
      hoverRadius: 9,
    },
  },
  animations: {
    tension: {
      duration: 1000,
      easing: 'linear',
      from: 0,
      to: 0.3,
    },
  },
};

const ChartBar = ({ chartData, labels }) => {
  const data = {
    labels,
    datasets: [
      {
        label: 'Dataset 1',
        data: chartData,
        backgroundColor: ['#9017A3', '#FEBE09', '#005B96', '#CC0056'],
        borderRadius: 10,
        barThickness: 40,
      },
    ],
  };

  return <Bar options={options} data={data} height='200' />;
};

export default ChartBar;
